import axios from '@service'
import { GET_INSURED_JUMP_LINK } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 获取 `投保` 跳转链接
export default async function getInsuredJumpLinkService(payload = {}, config = {}) {
    const param = {
        ...GET_INSURED_JUMP_LINK,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
